
import { useEffect } from 'react';

export const useEditorStyles = () => {
  useEffect(() => {
    // All styles are now handled by the editor-extensions.css file
    // This hook is kept for backward compatibility
    return () => {
      // Cleanup not needed
    };
  }, []);
};
